import type { UUID } from "../types";

type Side = "back" | "front";
type PersonalIdFileProps = { id: UUID; side?: Side };

export type PersonaIdFileName = `id_${Side}_${UUID}`;
export type PersonalIdFileKey = `personal_ids/${PersonaIdFileName}`;

export function getPhotoIDFileName({ id, side = "front" }: PersonalIdFileProps): PersonaIdFileName {
  return `id_${side}_${id}`;
}

export function getPhotoIDFileKey({ id, side = "front" }: PersonalIdFileProps): PersonalIdFileKey {
  return `personal_ids/${getPhotoIDFileName({ id, side })}`;
}
